import { shipmentStatuses } from '@reveni-io/reveni-ui'

import { trackingTypes } from '@/LabelTrackingPage/constants'

export const getStyleOptionsByTypeAndStatus = (type, status, isAlert, theme) => {
  if (type === trackingTypes.shipment || type === trackingTypes.fulfillment) {
    return getShipmentsStyleOptionsByStatus(theme)[isAlert ? 'alert' : status]
  } else if (type === trackingTypes.return) {
    return getReturnsStyleOptionsByStatus(theme)[isAlert ? 'alert' : status]
  }
}

export const getShipmentsStyleOptionsByStatus = theme => {
  return {
    [shipmentStatuses.ready]: { backgroundColor: theme.colors.blue.tone100, color: theme.colors.blue.tone700 },
    [shipmentStatuses.shipped]: { backgroundColor: theme.colors.blue.tone100, color: theme.colors.blue.tone700 },
    [shipmentStatuses.out_for_delivery]: {
      backgroundColor: theme.colors.blue.tone100,
      color: theme.colors.blue.tone700,
    },
    [shipmentStatuses.delivered]: {
      backgroundColor: theme.colors.green.tone100,
      color: theme.colors.green.tone700,
    },
    alert: {
      backgroundColor: theme.colors.orange.tone100,
      color: theme.colors.orange.tone700,
    },
  }
}

export const getReturnsStyleOptionsByStatus = theme => {
  return {
    [shipmentStatuses.ready]: { backgroundColor: theme.colors.pink.tone100, color: theme.colors.pink.tone700 },
    [shipmentStatuses.shipped]: { backgroundColor: theme.colors.blue.tone100, color: theme.colors.blue.tone700 },
    [shipmentStatuses.delivered]: {
      backgroundColor: theme.colors.green.tone100,
      color: theme.colors.green.tone700,
    },
    alert: {
      backgroundColor: theme.colors.orange.tone100,
      color: theme.colors.orange.tone700,
    },
  }
}
